import instance from '@apis/instance';
import { invalidateGetResponse } from 'utils/common';

const BASE_LOG_URL = '/log';

const fetchTotalPoints = () =>
  invalidateGetResponse<{ total: number }>({
    url: `${BASE_LOG_URL}/point/total`,
  });

const createErrorLog = (errorData: any) =>
  instance.post(`${BASE_LOG_URL}/error`, errorData);

export default {
  fetchTotalPoints,
  createErrorLog,
};
